<div class="dropdown w-full" *ngIf="request?.hasAdditionalInformation">
    <label tabindex="0" class="btn btn-ghost btn-xs">
        <iota-icon icon="information-circle"></iota-icon>&nbsp;<span i18n>Additional Information</span>
    </label>
    <div tabindex="0" class="dropdown-content p-2 rounded-lg text-sm bg-neutral text-neutral-content flex flex-col gap-1">
        <div class="flex flex-row justify-between gap-2 max-w-full" *ngIf="request?.note">
            <span class="font-medium" i18n>Annotation:</span>
            <span class="break-words whitespace-pre-wrap text-right">{{ request?.note }} </span>
        </div>

        <div class="flex flex-row justify-between gap-2 max-w-full" *ngIf="request?.subjectArea">
            <span class="font-medium" i18n>Subject area:</span>
            <span class="break-words whitespace-pre-wrap text-right">{{ request?.subjectArea }}</span>
        </div>

        <div class="flex flex-row justify-between gap-2" *ngIf="request?.preventionCourseTopicDescription">
            <span class="font-medium" i18n>Area of Application:</span>
            <span class="break-words whitespace-pre-wrap text-right">{{ request?.preventionCourseTopicDescription | hyphenate }}</span>
        </div>

        <div class="flex flex-row justify-between gap-2" *ngIf="request?.preventionCourse?.startDate">
            <span class="font-medium" i18n>Start date:</span>
            <span class="break-words whitespace-pre-wrap text-right">{{ request?.preventionCourse?.startDate | date: 'dd.MM.yyyy' }}</span>
        </div>

        <div class="flex flex-row justify-between gap-2" *ngIf="request?.preventionCourse?.endDate">
            <span class="font-medium" i18n>End date:</span>
            <span class="break-words whitespace-pre-wrap text-right">{{ request?.preventionCourse?.endDate | date: 'dd.MM.yyyy' }}</span>
        </div>

        <div class="flex flex-row justify-between gap-2" *ngIf="request?.preventionCourseGkvSubmissionDescription">
            <span class="font-medium" i18n>GKV submission:</span>
            <span class="break-words whitespace-pre-wrap text-right">{{ request?.preventionCourseGkvSubmissionDescription }}</span>
        </div>

        <div class="flex flex-row justify-between gap-2" *ngIf="request?.preventionCourse?.courseNumber">
            <span class="font-medium" i18n>Course number:</span>
            <span class="break-words whitespace-pre-wrap text-right">{{ request?.preventionCourse?.courseNumber }}</span>
        </div>

        <table class="border-collapse" *ngIf="request?.diopters">
            <thead>
                <tr>
                    <th class="px-1 border"></th>
                    <th class="px-1 border" i18n>Sph</th>
                    <th class="px-1 border" i18n>Zyl</th>
                    <th class="px-1 border" i18n>Ach</th>
                    <th class="px-1 border" i18n>Correction</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="px-1 border">R</td>
                    <td class="px-1 border">{{ request?.diopters?.right?.sphere }}</td>
                    <td class="px-1 border">{{ request?.diopters?.right?.cylinder }}</td>
                    <td class="px-1 border">{{ request?.diopters?.right?.axis }}</td>
                    <td class="px-1 border">{{ request?.diopters?.right?.correction }}</td>
                </tr>
                <tr>
                    <td class="px-1 border">L</td>
                    <td class="px-1 border">{{ request?.diopters?.left?.sphere }}</td>
                    <td class="px-1 border">{{ request?.diopters?.left?.cylinder }}</td>
                    <td class="px-1 border">{{ request?.diopters?.left?.axis }}</td>
                    <td class="px-1 border">{{ request?.diopters?.left?.correction }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
